export default __webpack_public_path__ + "static/media/176.9ae1856e.png";